// One connection value of an integrator, rendered from its driver manifest: the key is a
// LABEL (a typo in "propertyID" silently breaks the connection, so template keys are not
// editable), the value writes straight into Integrator.configValues. Secret keys use the
// IntegratorConnectionSecretCell template — same class, password input.
class IntegratorConnectionKeyCell extends UITableViewCell
{
    private keyLabel: MUILabel = null;
    private valueTextField: MUITextField = null;

    awakeFromHTML() {
        this.keyLabel = MUIOutlet(this, "key-lbl", "MUILabel");

        this.valueTextField = MUIOutlet(this, "value-tf", "MUITextField");
        this.valueTextField.setOnChangeText(this, function(this:IntegratorConnectionKeyCell, tf:MUITextField, value:string) {
            if (this._integrator == null || this._key == null) return;
            let values = this._integrator.configValues || {};
            values[this._key] = value;
            this._integrator.configValues = values;
        });

        this.selectionStyle = UITableViewCellSelectionStyle.None;
    }

    private _integrator: Integrator = null;
    private _key: string = null;

    setKey(key: string, optional: boolean, integrator: Integrator) {
        this._integrator = integrator;
        this._key = key;

        this.keyLabel.text = optional ? key + " — " + MIOLocalizeString("OPTIONAL", "optional") : key;

        let v = (integrator.configValues || {})[key];
        this.valueTextField.text = v == null ? "" : (typeof v == "string" ? v : JSON.stringify(v));
    }
}
